// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 22:30:04

export default {
  "id": "star-exiles",
  "slug": "star-exiles",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/5e16274ed7f741519cbf0ee2467115d3-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/5e16274ed7f741519cbf0ee2467115d3/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Star Exiles",
      "description": "Embark on an incredible adventure where the future of humanity is on the brink of an abyss. The earth has turned into a devastated desert after a terrible natural disaster. The only salvation for humanity is the colonization of other planets. Take part in a large-scale space expedition. You have to become one of the brave settler colonists, board a spaceship and fight the alien threat. Go to uncharted planets, look for resources for survival, create new settlements and protect them from enemies.",
      "instructions": "Controls in battle:\non a computer: use the mouse to control the direction of the ship's movement.\non phone: touch and swipe the screen in the direction you want to move your spaceship. Shooting is carried out automatically when you touch the screen.\nDuring the battle on the planet, be sure to destroy hotbeds of infection. Collect crystals and DNA to buy new spaceships.",
      "genres": [
        "Casual",
        "Shooter"
      ],
      "tags": [
        "2d",
        "arcade",
        "monster",
        "space"
      ]
    },
    "zh-CN": {
      "title": "星遗民",
      "description": "踏上一段惊心动魄的冒险之旅，人类的未来正处于深渊边缘。一场可怕的自然灾害将地球变成了荒芜的沙漠。人类唯一的救赎就是殖民其他星球。参与一场大规模的太空探险。你将成为一位勇敢的殖民开拓者，登上飞船，对抗外星威胁。前往未知的星球，寻找生存资源，建立新的定居点，并保护它们免受敌人侵害。",
      "instructions": "战斗控制：\n在电脑上：使用鼠标控制飞船的移动方向。\n在手机上：触摸并滑动屏幕以控制太空船移动。触摸屏幕时自动进行射击。\n在星球上的战斗中，务必摧毁感染源头。收集晶体和DNA来购买新飞船。",
      "genres": [
        "休闲",
        "射击"
      ],
      "tags": [
        "2D",
        "街机",
        "怪物",
        "太空"
      ]
    },
    "zh-TW": {
      "title": "星流浪者",
      "description": "踏上一次驚心动魄的冒險，人類的未來正處於淪陷邊緣。地球經過一次可怕的天然災害後，變成了荒涼的沙漠。人類唯一的救贖是開拓其他行星。參與一場大規模的太空探險。你必須成為一位勇敢的拓荒殖民者，登上太空船，對抗外星威脅。前往未知的行星，尋找生存資源，創建新殖民地，並保護它們不受敵人侵犯。",
      "instructions": "戰鬥控制：\n在電腦上：使用滑鼠控制船隻的移動方向。\n在手機上：触摸並在屏幕上滑動到你想要移動太空船的方向。觸碰屏幕時會自動進行射擊。\n在星球上的戰鬥中，請確保摧毀感染温床。收集水晶和DNA以購買新的太空船。",
      "genres": [
        "隨意遊戲",
        "射擊遊戲"
      ],
      "tags": [
        "2D",
        "街機",
        "怪物",
        "太空"
      ]
    },
    "zh-HK": {
      "title": "星遠征者",
      "description": "踏上一次驚人的冒險，人類的未來正處於淪陷邊緣。地球在可怕的天然災害後變成了毀滅的沙漠。人類唯一的救贖是殖民其他行星。參與一場大規模的太空探險。你必須成為一位勇敢的殖民開拓者，登上太空船，與外星威脅作戰。前往未知的行星，尋找生存資源，創建新聚落，並保護它們免受敵人侵犯。",
      "instructions": "戰鬥中的操控：\n在電腦上：使用滑鼠控制船隻的移動方向。\n在手機上：觸摸並在您想移動太空船的方向上掃描屏幕。觸摸屏幕時會自動進行射擊。\n在星球上的戰鬥中，請確保摧毀感染熱點。收集水晶和DNA以購買新的太空船。",
      "genres": [
        "隨意",
        "射擊"
      ],
      "tags": [
        "二維",
        "街機",
        "怪物",
        "太空"
      ]
    },
    "ja": {
      "title": "スター・エリージェズ",
      "description": "人類の未来が絶望の淵に立っている驚異的な冒険に参加してください。恐ろしい自然災害の後、地球は荒廃した砂漠に変わり果てました。人類にとって唯一の救済は他の惑星への植民です。大規模な宇宙探検に参加してください。あなたは勇敢な植民者となり、宇宙船に乗り込み、異星人の脅威と戦わなければなりません。未知の惑星へ行き、生存のための資源を探し、新しい植民地を築き、敵から守ることになります。",
      "instructions": "戦闘時のコントロール：\nコンピューター上では、マウスを使用して船の動きの方向を操作します。\n携帯電話上では、スクリーンにタッチしてスワイプして、宇宙船の移動したい方向に操作します。スクリーンにタッチすると、自動的に射撃が行われます。\n惑星での戦闘中は、感染の温床を必ず破壊してください。クリスタルとDNAを収集して、新しい宇宙船を購入してください。",
      "genres": [
        "カジュアル",
        "シューター"
      ],
      "tags": [
        "2D",
        "アーケード",
        "モンスター",
        "宇宙"
      ]
    },
    "ko": {
      "title": "별 이적자",
      "description": "인류의 미래가 지쳐 있는 무덤 끝자락에서 벌어지는 놀라운 모험에 참여해 보세요. 끔찍한 자연재해로 인해 지구는 파괴된 사막으로 변했습니다. 인류를 구할 수 있는 유일한 구원은 다른 행성에 정착하는 것입니다. 대규모 우주 탐사에 참여하세요. 당신은 용감한 정착자 중 한 명이 되어 우주선에 탑승하고 외계적인脅협과 싸워야 합니다. 불확 định한 행성으로 가서 생존을 위한 자원을 찾고, 새로운 정착지를 세우고 적으로부터 지키세요.",
      "instructions": "전투 중 제어법:\n컴퓨터에서: 마우스를 사용하여 배의 이동 방향을 조정합니다.\n폰에서: 화면을 원하는 방향으로 탭하고 스와이프하여 우주선을 이동시킵니다. 화면을 탭하면 자동으로 발사됩니다.\n행성 전투 중에 감염의 발원지를 파괴하는 것을 잊지 마세요. 크리스탈과 DNA를 수집하여 새로운 우주선을 구매하세요.",
      "genres": [
        "캐주얼",
        "총기쏘기"
      ],
      "tags": [
        "2D",
        "아케이드",
        "몬스터",
        "우주"
      ]
    },
    "fr": {
      "title": "Étoiles Émigrés",
      "description": "Embarkez sur une aventure incroyable où l'avenir de l'humanité est au bord du gouffre. La Terre s'est transformée en une désert dévasté après une terrible catastrophe naturelle. La seule salvation pour l'humanité est la colonisation d'autres planètes. Participez à une expédition spatiale à grande échelle. Vous devez devenir l'un des courageux colons pionniers, monter à bord d'une navette spatiale et combattre la menace alien. Dirigez-vous vers des planètes inexplorées, cherchez des ressources pour survivre, créez de nouvelles colonies et les protégez contre les ennemis.",
      "instructions": "Contrôles en combat :\nsur ordinateur : utilisez la souris pour contrôler la direction de la movement du navire.\nsur téléphone : touchez et glissez sur l'écran dans la direction où vous voulez déplacer votre vaisseau spatial. L'attaque est effectuée automatiquement lorsque vous touchez l'écran.\nDurant le combat sur la planète, assurez-vous de détruire les foyers d'infection. Collectez des cristaux et de l'ADN pour acheter de nouveaux vaisseaux spatiaux.",
      "genres": [
        "Facile",
        "tireur"
      ],
      "tags": [
        "2D",
        "arcade",
        "monstre",
        "espace"
      ]
    }
  }
};
